<template>
    <div class="pool">
        <div class="select_box">
            <el-input
                placeholder="请输入要搜索的文件"
                prefix-icon="el-icon-search"
                clearable
                v-model="Searchipu"
                @input="ChangeIpt"
                @clear="clear"
                >
            </el-input>
        </div>
        <div class="list_box">
            <ul v-if="FileList.length > 0">
                <li class="lis" v-for="(i,index) in FileList" :key="index" @click="handPDF(i.FileName)">
                    {{ i.FileName }}
                </li>
            </ul>
            <van-empty v-else description="暂时还没上传文件。。。" />
        </div>
        <el-dialog width="90%" :visible.sync="pdfVisible">
            <!-- <pdf :src="pdfUrl" ref="pdf" v-for="i in numPages" :key="i" :page="i"></pdf> -->
            <div id="demo"></div>
        </el-dialog>
    </div>
</template>

<script>
import mNav from "@/components/mNav.vue";
import http from '@/assets/js/http.js';
import axios from 'axios';
import  pdf  from 'vue-pdf';
import { Dialog,ImagePreview } from 'vant';
import {Loading} from 'element-ui';
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default {
    name: "Pool",
    components: {
        mNav,
        pdf,
    },
    data() {
        return {
            msg: sessionStorage.SportName,
            isActive: 0,
            FileList: [],
            pdfUrl: '',
            pdfVisible: false,
            numPages: 0,
            pdfh5: null,
            Searchipu: '',
            rest_FileList:[],
            loadingInstance: {},
        }
    },
    mounted() {
        // console.log(console.log(this.$route);)
        // console.log(this.$route);
        this.loadingInstance = Loading.service({
            lock: true,
            text: '正在加载,请稍后...',
        });
        this.GetFileName();
    },
    
    methods: {
        ChangeIpt(val){//当输入框的值发生改变
            // console.log(val)
            let newarr = [];
            this.FileList = this.rest_FileList;
            // 存在运动员判断条件
            if (this.rest_FileList.length > 0 && val !='') {
                newarr = this.FileList.filter(ele => {
                    return ele.FileName.includes(val)
                })
                // console.log(newarr);
                return this.FileList = newarr;
            }else{
                this.FileList = this.rest_FileList;
            }
           

        },
        clear(){

        },
        handPDF(i){
            console.log(i)
            let index = i .lastIndexOf(".")
            let str = i.substring(index+1,i.length);
            console.log(str) //

            axios.get('/Sports/BDM/'+sessionStorage.SportCode+'/Files/'+i+'?v='+Math.random()).then(res=>{
                this.loadingInstance.close();  // 关闭加载遮罩层
                // console.log(res)
                if(res.status == 200) {
                    if(str.toLowerCase() == 'png' && str.toLowerCase() == 'jpg' && str.toLowerCase() == 'jpeg' && str.toLowerCase() == 'gif'){
                        ImagePreview(['http://39.100.55.139:10015/Sports/BDM/'+sessionStorage.SportCode+'/Files/'+i+'?v='+Math.random()]);
                    }else {
                        window.open('http://39.100.55.139:10015/Sports/BDM/'+sessionStorage.SportCode+'/Files/'+i+'?v='+Math.random());
                        
                    }
                    // this.pdfVisible = true;
                    // this.pdfUrl = 'http://assess.holy-sport.com:8001/Sports/TTE/'+sessionStorage.SportCode+'/Files/'+i;
                    // this.getTotal('http://assess.holy-sport.com:8001/Sports/TTE/'+sessionStorage.SportCode+'/Files/'+i);
                    
                }else{
                    Dialog.alert({
                        message: '暂未上传该比赛文件'
                    }).then(() => {
                        let loadingInstance = Loading.service();
                        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                            loadingInstance.close();
                        });
                    });
                }
            })
        },
        GetFileName(){//获取文件列表
            http.GetFileName(sessionStorage.SportCode).then(res=>{//获取赛事列表地址
                console.log(res)
                this.loadingInstance.close();  // 关闭加载遮罩层
                if(res.Status === 200){
                    this.FileList = res.DataResult;
                    this.rest_FileList = res.DataResult;
                }else{
                    this.FileList = [];
                    this.rest_FileList = [];
                }
            })
        },
        getTotal(url) {//获取pdf总页数
            this.pdfUrl = pdf.createLoadingTask(url);
            this.pdfUrl.promise.then(pdf=>{
                this.numPages = pdf.numPages;
            })
        }
    },
}
</script>

<style lang="scss" scoped>
    $bgColor: #3641C9;
    ::v-deep .van-collapse-item__title--disabled, .van-collapse-item__title--disabled .van-cell__right-icon{
        color: #333;
    }
    ::v-deep .pinch-zoom-container{
        min-height: 450px;
        height: auto;
    }
    .pool{
        font-size: 20px;
        padding: 20px;
    }
    .list_box{
        padding: 10px;
    }
    .lis{
        padding: 20px 0;
        background: white;
        border-bottom: 1px solid $bgColor;
        text-indent: 30px;
        font-size: 20px;
        color: $bgColor;
    }
    .select_box{
        padding: 10px;
    }
</style>